module.exports = __webpack_public_path__ + "static/media/auth-bg-1-old.5efd61d0.jpg";